:root {
  --modal-background: #d2d2d2aa;
}

.modalOverlay {
  position: fixed;
  background-color: var(--modal-background);
  inset: 0;
  z-index: 11;
  justify-content: center;
  align-items: center;
}

.modalDialog {
  background-color: var(--white);
  border: 1px solid var(--blue);
  padding: 1.5em;
  position: fixed;
  min-width: 20em;
  max-width: 30em;
  margin: auto;
  display: flex;
  flex-direction: column;

  &.large {
    max-width: 35em;
  }
}

.modalDialog p {
  margin: 0 0 1em;
}

.modalDialog label {
  line-height: normal;
}

.modalButtons {
  margin-top: 2em;
  margin-left: auto;
  display: flex;

  & > button {
    display: inline-block;
  }
}

.modalButton {
  border-radius: 0;
  display: inline-block;
  margin-left: 1em;

  &:disabled {
    cursor: default;
    background-color: var(--darkSilver);
  }
}

.modalTitle {
  color: var(--lightGray);
  padding-bottom: 0.5em;
}
